import { Control } from "../Control.js";

function width(value) {

    if (value === undefined || value === null)
        return '';
    if (value === 'auto' || value === 'max')
        return '.max';
    if (value === 'shrink' || value === 'min')
        return '.min';

    const numericValue = parseInt(value);
    if (Number.isNaN(numericValue) || numericValue <= 0)
        return '';

    return `.s${numericValue}`;

}

export class FlexCell extends Control {

    constructor(parent, params = {}) {

        params = Object.assign({
            width: 12,
            controls: []
        }, params || {});

        super(parent, params);

        const {
            width = 12,
            controls = [],
        } = params;

        this.width = width;
        this.controls = controls;
        this.controls.forEach((control) => {
            if (control)
                control.parent = this;
        });

    };

    _render(r, vm) {

        const renderer = r;

        var props = {},
            style = (width(this.width) || '') + (this.getCss() || ''),
            controls = this.controls.map(function (control) {
                if (!control)
                    return null;
                return control.render(renderer, vm);
            });

        return renderer.cell({ css: style, props }, controls);

    };

}

export class FlexGrid extends Control {

    constructor(parent, params = {}) {

        params = Object.assign({
            width: null,
            cells: []
        }, params || {});

        super(parent, params);

        const {
            width = null,
            cells = [],
        } = params;

        this.width = width;
        this.cells = cells;

        return this;

    };

    cell(options = {}) {

        this.cells.push(new FlexCell(this, options));
        return this;

    };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        var props = {
            vertical: this.vertical,
        },
            style = (width(this.width) || '') + (this.getCss() || ''),
            cells = this.cells.map(function (cell) {
                if (!cell)
                    return null;
                return cell.render(renderer, vm);
            });

        return renderer.grid({ css: style, props }, cells);

    };

}
